import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { AllActionsQuery, AllActionsQueryVariables } from '../../../../data-access/gql-types/graphql';
import { ALL_ACTIONS } from '../../../../data-access/queries/actions';
import { useActionsStore } from '../../store/actions';
import { useCacheStore } from '../../store/cache';
import { UserActionsCollectionSegmentPick } from '../../types/cache';

export const useUserActions = () => {
  useTranslation('action');
  const { selectedInstallationId, skipLavvaFetch } = useInstallationContext();
  const setActions = useActionsStore((s) => s.setActions);
  const actionsSkip = useCacheStore((s) => s.actionsSkip);
  const { data, loading } = useQuery<AllActionsQuery, AllActionsQueryVariables>(ALL_ACTIONS, {
    variables: { installationId: selectedInstallationId },
    fetchPolicy: 'network-only',
    skip: skipLavvaFetch || actionsSkip,
  });

  useEffect(() => {
    if (data?.userActions) setActions(data.userActions as UserActionsCollectionSegmentPick, true);
  }, [data?.userActions]);

  return {
    loading,
  };
};
